import React, { createContext, useContext, useState, useEffect } from "react";

const UserEmailContext = createContext();

export const UserEmailProvider = ({ children }) => {
  const [userEmail, setUserEmail] = useState(() => {
    // Load the initial Email from localStorage
    return localStorage.getItem("userEmail") || null;
  });

  useEffect(() => {
    // Update localStorage whenever userEmail changes
    if (userEmail) {
      localStorage.setItem("userEmail", userEmail);
    } else {
      localStorage.removeItem("userEmail");
    }
  }, [userEmail]);

  return (
    <UserEmailContext.Provider value={{ userEmail, setUserEmail }}>
      {children}
    </UserEmailContext.Provider>
  );
};

export const useUserEmail = () => useContext(UserEmailContext);
